import { IconWarningSolid, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";

const ErrorBody = () => {
  const { t } = useTranslation();
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ marginBottom: "1.5rem" }}>
        <IconWarningSolid color="error" size="medium" />
      </div>
      <Text size="medium" as="p" weight="bold" color="primary">
        {t("finalizeCourse.errorBody")}
      </Text>
    </div>
  );
};

export default ErrorBody;
